module.exports = __webpack_public_path__ + "static/media/salesforce-logo.060d07c2.svg";